import React, { Dispatch, FunctionComponent, ReactNode, useState } from 'react'
import AriaModal from 'react-aria-modal'
import cn from 'classnames'
import Octicon, { X } from '@primer/octicons-react'
import { PrimitiveAtom, useAtom } from 'jotai'

import {catchFocusAtom } from '../../states'
import { ModalInner, Animation } from './styles'
import styles from '~/styles/modal.module.css'

interface Props {
  children: ReactNode
  title: string,
  isOpen: boolean,
  setIsOpen: Dispatch<boolean>,
  dialogClass?: string
}

const Modal: FunctionComponent<Props> = ({
  children,
  title,
  isOpen,
  setIsOpen,
  dialogClass = '',
  onModalClose,
}: Props) => {
  const [modalHasEntered, setModalHasEntered] = useState(false)
  const [, setCatchFocus] = useAtom(catchFocusAtom)

  const onModalEnter = () => {
    setModalHasEntered(true)
  }

  const deactivateModal = () => {
    setModalHasEntered(false)
    setCatchFocus(true)
	if (typeof onModalClose === 'function') {
		onModalClose()
	}
    setTimeout(() => {
      setIsOpen(false)
      //: change to AnimatePresence from framer-motion
    }, 100) // This number should be faster than the transition speed in ./styles.ts
  }

	let arialModalAlignItems = 'center'
	let modalInnerPaddingClass = 'pt-6 pb-4 px-4'
	let marginTopClass = 'mt-4'
	if (title === 'New Order') {
		arialModalAlignItems = 'flex-start'
		modalInnerPaddingClass = 'pt-2 pb-2 px-4'
		marginTopClass = styles.modal
		// dialogClass = 'flex items-center h-full' it doesn't help on low height screens
	}

  return (
    <AriaModal
      titleText={title}
      onEnter={onModalEnter}
      onExit={deactivateModal}
      mounted={isOpen}
      underlayStyle={{
        display: 'flex',
        alignItems: arialModalAlignItems,
        justifyContent: 'center',
        zIndex: 100000,
      }}
      dialogClass={dialogClass}
    >
      <Animation
        className={cn('modal--animated', {
          'has-entered': modalHasEntered,
        })}
      >
        <ModalInner className={"bg-white rounded mb-6 relative overflow-hidden " + modalInnerPaddingClass}>
          <button
            className="py-1 px-2 m-1 absolute right-0 top-0 text-gray-800 cursor-pointer z-30"
            onClick={deactivateModal}
          >
            <Octicon icon={X} />
          </button>
          <div className={marginTopClass}>{children}</div>
        </ModalInner>
      </Animation>
    </AriaModal>
  )
}

export default Modal
